import React from 'react';
import './AboutMeSection.css';
// import { Link } from 'react-router-dom';

function AboutMeSection() {
    return (
        <div className="about-me-wrapper">
          <div className="about-me-content">
            <h2>About Me</h2>
            <p>
              I am a Romantic. I love to Love and I devote myself to cultivating a state of presence that can have the capacity to lovingly transform the spaces I inhabit and move through.
            </p>
            <p>
              My strongest guide and mentor is my cat, Areia, and it is through her that I found my religion. My religion is that of Eros, of devotion, of the body, of connection, of nurturance, and of the wild and instinctual.
              I believe that to heal is to become undomesticated, because the Soul does not speak in the language of man-made rules. To follow the Soul is to follow the uncharted path of the wild and unknown.
            </p>
            <p>My personal journey has consisted of finding the psychological tools and strength to be able to allow my Soul to move freely while keeping loving contact with the people and world around me.</p>
            <p>I have learned from my cat to love life for the sole purpose of it being Alive, and to love her and myself for the simple fact that we just are.</p>
            <p>My longing is to provide a space where people can just be.</p>
          </div>
    
          <div className="about-me-images">
            <img src="/images/portrait.jpg" alt="Portrait" className="portrait" loading="lazy" decoding="async" />
            <img src="/images/areia.jpg" alt="Cat" className="cat" loading="lazy" decoding="async" />
          </div>
          {/* <div className="about-me__contact-row">
            <Link to="/contact" className="about-me__contact-btn">
              Get in touch
            </Link>
          </div> */}
        </div>
      );
}

export default AboutMeSection;
